import styled from 'styled-components';

import { VFlex } from '@/components/base';
import { customScrollbar, modalStyle } from '@/styles/style';

const MainLayout = styled(VFlex)`
  flex: 1;
  ${modalStyle};
  background-color: ${(props) => props.theme.colors.gray100};
  .header {
    padding: 32px;
    gap: 8px;
  }
  .body {
    flex: 1;
    padding: 24px 32px;
  }
  .footer {
    gap: 12px;
    padding: 24px 32px;
  }
`;

const PreviewLayout = styled(VFlex)`
  width: 400px;
  padding: 40px 32px;
  ${modalStyle};
  background-color: ${(props) => props.theme.colors.gray250};
  overflow: auto;
  ${customScrollbar};
`;

const CreateTopicModalStyles = { MainLayout, PreviewLayout };

export default CreateTopicModalStyles;
